import Vue from "vue";
import Vuex from "vuex";

import i18n from "../locales";
import countries from "../config/countries";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentProfile: undefined,
  },
  mutations: {
    setCurrentProfile(state, profile) {
      state.currentProfile = profile;

      const country = countries.find((country) => country["alpha-2"] === profile.country);
      i18n.locale = country?.locale;
    },
  },
  actions: {},
  modules: {},
});
